export const modalities = [
  {
    id: 'musculacao',
    name: 'Musculação',
    description: 'Treinos para força, saúde, condicionamento e evolução física com equipamentos e pesos livres.',
    audience: 'Para todos os níveis e objetivos',
    image: 'https://storage.readdy-site.link/project_files/1a1c8768-7964-48a6-af85-b4ce5b39e023/6d4dbf8a-317c-491d-88e6-031c2cef13df_enhanced_TopGym0003.jpg?v=e82d0a9b04356a27c659f3b3851e6e85',
    tag: 'Mais Popular',
  },
  {
    id: 'cross-training',
    name: 'Cross Training',
    description: 'Treinos variados e intensos que combinam diferentes modalidades para resultado máximo.',
    audience: 'Quem busca desafio e variedade',
    image: 'https://storage.readdy-site.link/project_files/1a1c8768-7964-48a6-af85-b4ce5b39e023/2470a362-59d1-4771-99e5-d08c8129647f_TopGym00019.jpg?v=a6dbc4a0b03fc6ad187d68bc548c5c15',
    tag: null,
  },
  {
    id: 'circuito-funcional',
    name: 'Circuito Funcional',
    description: 'Aulas dinâmicas com movimentos naturais que melhoram resistência, agilidade e coordenação.',
    audience: 'Ideal para condicionamento geral',
    image: 'https://storage.readdy-site.link/project_files/1a1c8768-7964-48a6-af85-b4ce5b39e023/7a5050f0-3418-47f6-a4b5-71a54f51fd3b_TopGym00016.jpg?v=c7985afd411670fb267d4597c5c67c4c',
    tag: null,
  },
  {
    id: 'muay-thai',
    name: 'Muay Thai e Jiu Jitsu',
    description: 'Artes marciais que desenvolvem técnica, condicionamento físico, defesa pessoal e autoconfiança.',
    audience: 'Para iniciantes e praticantes de ambas modalidades',
    image: 'https://storage.readdy-site.link/project_files/1a1c8768-7964-48a6-af85-b4ce5b39e023/8dbe0c00-44f8-4f60-a767-fb5a8814cf52_enhanced_TopGym0005.jpg?v=d364248728d6003e2c1b9dc70f4a7481',
    tag: null,
  },
];